import axios from 'axios'
import moment from 'moment'
import { now, formatDateWithTimezone, timeWithoutTimeZone, displayDate } from '../../../utils/utcTime'

import {
  SET_CONTACT_NAME,
  SET_INITIAL_TASK_DATA,
  EDIT_TASK_DATA,
  SET_NUMBER_OF_DUE_DATE_TASKS,
  SET_NUMBER_OF_TODAY_TASKS,
  SELECT_TASK,
  CHECK_ALL,
  SET_TASKS_SUMMARY,
  SET_TASK_FILTERS,
  EDIT_EVENT_DATA,
  EDIT_EVENT_DATA_FROM_TASK,
  SET_DATA_FOR_TASK_REPORT,
  GET_NOTES_FOR_TIMELINE,
  CLEAR_EVENT_DATA_FROM_TASK,
  CLEAR_EVENT_DATA,
  SET_EVENT_DATA_FROM_TASK,
  SET_TODAY_MEETING,
  RESET_ALL_DATA,
  IS_HAD_MEETING,
  SET_NEXT_WEEK_DATE,
  SET_LOADING,
  SET_TASK_EDITING,
  SET_TASK_COMPLETING,
  CLEAR_DASHBOARD_TASKS,
  GET_TASKS_FOR_DASHBOARD,
  RESET_TASKS_FILTERS,
  GET_USER_MONTHLY_TASK_STATISTIC,
  IS_SHARED_NOTE,
  EDIT_SHARED_NOTE_DATA,
} from './types'
// import { notificationSuccess } from "../../../utils/customToastify"; TODO
import { getValueForReminder } from '../reminderOptions'
import { closeModal } from '../../../common/GlobalModal/redux/GlobalModalActions'
import { assignUser, getHistoryData } from '../../Contacts/redux/ContactActions'
import { notificationDanger, notificationSuccess } from '../../../utils/customToastify'
import { EMAIL, getNormalizedActivityName, MEETING, OUT_GOING_CALL } from '../../../constants/activityTypes'
import isEmpty from '../../../utils/isEmpty'
import { setCustomError } from '../../../actions/errorsActions'
import { createExpense } from '../../Expenses/redux/expenseActions'
import {
  FOLLOW_UP_NEXT_STEPS,
  FOLLOW_UP_NEXT_WEEK,
  FOLLOW_UP_PER_POLICY,
  FOLLOW_UP_TOMORROW,
  NONE,
  NO_ANSWER_CALL_BACK_2_HOURS,
} from '../../../constants/taskConstants'
import { isNotEmptyArray } from '../../../utils/arrayUtils'

export const clearEventDataFromTask = () => ({
  type: CLEAR_EVENT_DATA_FROM_TASK,
})

export const clearEventData = () => ({
  type: CLEAR_EVENT_DATA,
})

export const setIsHadMeeting = (value) => (dispatch) => {
  dispatch({
    type: IS_HAD_MEETING,
    payload: value,
  })
}

export const setIsSharedNote = (value) => (dispatch) => {
  dispatch({
    type: IS_SHARED_NOTE,
    payload: value,
  })
}

export const editSharedNoteData = (name, value) => (dispatch) => {
  dispatch({ type: EDIT_SHARED_NOTE_DATA, payload: { name, value } })
}

export const resetAllData = () => ({
  type: RESET_ALL_DATA,
})

export const resetTaskFilters = () => ({
  type: RESET_TASKS_FILTERS,
})

export const getContactName = (contactId) => async (dispatch, getState) => {
  const divisionId = getState().auth.user.division_id
  const response = await axios.get(`/contacts/contact-name/${contactId}`, { params: { divisionId } })
  if (response.status === 200) {
    dispatch({
      type: SET_CONTACT_NAME,
      payload: response.data && response.data,
    })
  }
  return response.data
}

export const getNotesForTask = (contactId) => async (dispatch) => {
  const response = await axios(`/task/get-notes/?contact_id=${contactId}`)
  dispatch({
    type: GET_NOTES_FOR_TIMELINE,
    payload: response.data,
  })
}

export const saveTask = (data) => async () => {
  await axios.post(`/task/`, { dataForTask: data })
}

export const createTasks = (contactIds, callback) => async (dispatch, getState) => {
  const state = getState()
  const { data } = state.Task

  const eventData = state.Task.eventDataFromTask || {}

  if (isNotEmptyArray(contactIds)) {
    const isValid = validateTaskData(data, eventData, dispatch)

    if (isValid) {
      const { assigned } = data

      const selectedRows = contactIds.map((id) => {
        return { id }
      })
      const assignResult = await dispatch(assignUser(assigned, selectedRows))

      if (!assignResult) {
        return
      }

      for (let i = 0; i < contactIds.length; i++) {
        const contactId = contactIds[i]
        const assignedArray = await isTaskAssigned(assigned, contactId)
        const isAssigned = isNotEmptyArray(assignedArray)

        if (!isAssigned) {
          dispatch(createOrUpdateTask(null, contactId, true))
        }
      }

      // clear data after looping is over

      dispatch(closeModal('task_modal'))

      setTimeout(() => {
        dispatch(resetAllData())
        dispatch(setTodayMeeting({}))
        dispatch(clearEventDataFromTask())
        if (typeof callback === 'function') {
          callback()
        }
      }, 2000)
    }
  }
}

export const saveTaskForActivity = (id, contactIdFromFunction, activityId) => (dispatch) => {
  dispatch(createOrUpdateTask(id, contactIdFromFunction, false, activityId))
}

// validation for multiple task creation
// eventData/dispatch are kept for the disabled meeting validation below - the block that reads
// them is commented out, not deleted, so the signature stays as the caller passes it.
// eslint-disable-next-line no-unused-vars
const validateTaskData = (data, eventData, dispatch) => {
  if (!data?.title) {
    notificationDanger('Please Enter Subject')
    return false
  }

  // if (!data?.selectedActivityType) {
  // notificationDanger('Please Select Activity Type')
  // return false
  // }

  if (data?.selectedActivityType === MEETING) {
    //! disabled
    // if (isEmpty(eventData.meetingStart)) {
    //   dispatch(setCustomError('meetingStart', 'Meeting Start Date is required'))
    //   return false
    // }
    // if (isEmpty(eventData.meetingEnd)) {
    //   dispatch(setCustomError('meetingEnd', 'Meeting End Date is required'))
    //   return false
    // }
  }

  return true
}

const createOrUpdateTask = (id, contactIdFromFunction, multipleCreation, activityId) => async (dispatch, getState) => {
  const state = getState()
  const { data, query } = state.Task

  if (!multipleCreation) {
    if (!data?.title) {
      notificationDanger('Please Enter Subject')
      return
    }

    // if (!data?.selectedActivityType && !data?.activityType) {
    // notificationDanger('Please Select Activity Type')
    // return
    // }
  }

  const eventData = state.Task.eventDataFromTask || {}
  const otherContactData = state.Task.otherContactData
  const { division_id: divisionId } = state.auth.user
  const { selectedActivityType, dueDate, reminder, attachments, ...rest } = data

  if (id) {
    const dataForUpdate = {
      priority: rest.priority ? 1 : 0,
      dueDate: dueDate ? moment(dueDate).utc() : '',
      assigned: rest.assigned,
      title: rest.title,
      status: rest.status,
      activityType: selectedActivityType || rest.activityType,
      description: rest.description,
      referralId: rest.referralId,
    }

    //! to prevent task creation if event creation fails
    if (dataForUpdate.activityType === MEETING) {
      // if (isEmpty(eventData.meetingStart)) {
      //   dispatch(setCustomError('meetingStart', 'Meeting Start Date is required'))
      //   return
      // }
      // if (isEmpty(eventData.meetingEnd)) {
      //   dispatch(setCustomError('meetingEnd', 'Meeting End Date is required'))
      //   return
      // }
    }

    const formData = new FormData()

    formData.append('dataForTask', JSON.stringify(dataForUpdate))

    if (attachments && attachments.length) {
      attachments.forEach((attachment) => {
        formData.append('attachments', attachment)
      })
    }

    await axios
      .patch(`/task/${id}`, formData)
      .then(async () => {
        if (state.Task.isEditing) {
          dispatch(getHistoryData(contactIdFromFunction || data.contactId, 4))
          dispatch(setTaskEditing(false))
        }

        if (dataForUpdate.activityType === MEETING) {
          await saveMettingFromTask(selectedActivityType, eventData, otherContactData, id, data.activityType)
        }

        dispatch(getDashboardTasks({ first: 0, limit: query.limit }, true))
        dispatch(closeModal('task_modal'))

        if (!multipleCreation) {
          dispatch(clearEventDataFromTask())
        }

        notificationSuccess('Task updated successfully')
      })
      .catch(() => {})
    return
  }

  const dataForTask = {
    ...rest,
    status: 0,
    priority: rest.priority ? 1 : 0,
    contactId: contactIdFromFunction || data.contactId,
    dueDate: dueDate ? moment(dueDate).utc() : '',
    // dueDate:
    //   selectedActivityType === MEETING
    //     ? eventData.meetingEnd
    //       ? moment(eventData.meetingEnd).utc()
    //       : ''
    //     : dueDate
    //     ? moment(dueDate).utc()
    //     : '',
    divisionId,
    activityType: selectedActivityType,
    creationDate: now(),
  }

  delete dataForTask.isDemo
  delete dataForTask.isNoteChecked
  delete dataForTask.selectedNextStep
  delete dataForTask.contact_id

  // if (dataForTask.activityType === MEETING && isEmpty(dataForTask.dueDate)) {
  //   dispatch(setCustomError('meetingEnd', 'Meeting End Date is required'))
  //   return
  // }

  //! to prevent task creation if event creation fails
  // if (dataForTask.activityType === MEETING) {
  //   if (isEmpty(eventData.meetingStart)) {
  //     dispatch(setCustomError('meetingStart', 'Meeting Start Date is required'))
  //     return
  //   }

  //   if (isEmpty(eventData.meetingEnd)) {
  //     dispatch(setCustomError('meetingEnd', 'Meeting End Date is required'))
  //     return
  //   }
  // }

  const formData = new FormData()
  formData.append('dataForTask', JSON.stringify(dataForTask))
  // formData.append('eventData', JSON.stringify(eventData))

  if (attachments && attachments.length) {
    attachments.forEach((attachment) => {
      formData.append('attachments', attachment)
    })
  }

  const responseCreatedTask = await axios.post('/task', formData)

  // link attachments with task
  if (activityId) {
    await axios.patch(`/activity/link-attachments/activity`, { activityId, taskId: responseCreatedTask?.data?.id })
  }

  if (reminder) {
    const { type, time } = getValueForReminder(reminder)
    const { contact } = state.contacts
    const activityName = getNormalizedActivityName(selectedActivityType) ?? 'task'
    const taskDueDate = selectedActivityType === MEETING ? eventData.meetingEnd : dueDate
    const scheduledTime = moment(taskDueDate).utc().subtract(time, type)

    await axios.post('/notifications', {
      scheduledTime,
      user_id: rest.assigned,
      title: `${time} ${type} Reminder: ${activityName} ${contact.name}`,
      text: `New Task Scheduled: ${activityName} ${contact.name} ${displayDate(taskDueDate, 'h:mm A, MMMM Do, YYYY')}`,
    })
  }

  if (dataForTask.activityType === MEETING) {
    await saveMettingFromTask(
      selectedActivityType,
      eventData,
      { contactId: responseCreatedTask?.data?.contactId },
      responseCreatedTask?.data?.id
    )
  }
  // dispatch(clearEventDataFromTask())
  dispatch(closeModal('task_modal'))
}

export const setIsLoading = () => ({ type: SET_LOADING })

export const completeTask = (id, newActivityType, activityAction, sendEmail = false) => async (dispatch, getState) => {
  const state = getState()
  const userData = state.auth.user
  const eventData = state.Task.eventData
  const sharedNoteData = state.Task.sharedNoteData
  const taskData = state.Task.data
  const isHadMeeting = state.Task.isHadMeeting
  const isSharedNote = state.Task.isSharedNote
  const query = state.Task.query
  const c2cData = state.ClickToCall

  dispatch(setIsLoading())
  if (!taskData.nextStepId) {
    dispatch(setCustomError('nextStep', 'Next step is required'))
    return
  }

  // Event have to be created first because of error checking
  let eventId
  if (isHadMeeting) {
    // CREATE EVENT
    const { ...rest } = eventData
    const response = await axios.post(`/events`, {
      ...rest,
      contactId: taskData.contactId,
      subject: taskData.title,
      note: taskData.description,
      taskId: taskData.id,
      // When a Moment object is passed, it will be sent as UTC time.
      meetingStart: eventData.meetingStart ? moment(eventData.meetingStart) : '',
      meetingEnd: eventData.meetingEnd ? moment(eventData.meetingEnd) : '',
      completeData: true,
      creationDate: now(),
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    })

    eventId = response?.data[0]?.id
  }

  let newSharedNoteId
  if (isSharedNote && sharedNoteData.note) {
    const contactId = state.Task?.data?.contactId

    if (contactId) {
      const note = {
        ...sharedNoteData,
        subject: taskData.title,
        creationDate: now(),
        createdBy: userData.userId,
        contactId,
        divisionId: userData.division_id,
      }

      const newSharedNoteResponse = await axios.post(`/activity/shared-notes`, note)
      newSharedNoteId = newSharedNoteResponse?.data?.[0]?.id
    }
  }

  //! CREATE NEW TASK
  if (taskData.nextStepId !== NONE) {
    if (FOLLOW_UP_NEXT_STEPS.includes(taskData.nextStepId) && !taskData.followUpDate) {
      dispatch(setCustomError('followUpDate', 'Follow Up Date is required'))
      return
    }
    // the follow up next steps show the date in the picker, so what the user sees there is
    // authoritative. The rest keep their computed due date - "No Answer - Call Back 2 Hours"
    // sets nextStepId straight from ConvertContact and can leave a followUpDate behind.
    const newDueDate = FOLLOW_UP_NEXT_STEPS.includes(taskData.nextStepId)
      ? taskData.followUpDate
      : handleDueDate(taskData)

    const newTaskFormData = new FormData()

    const newTaskData = {
      status: 0,
      priority: 0,
      contactId: taskData.contactId,
      dueDate: moment(newDueDate).utc(),
      divisionId: taskData.divisionId,
      activityType: newActivityType,
      description: taskData.description,
      assigned: taskData.assigned,
      title: taskData.title,
      creationDate: now(),
    }

    newTaskFormData.append('dataForTask', JSON.stringify(newTaskData))

    await axios.post(`/task`, newTaskFormData, {
      params: {
        sendEmail,
      },
    })
  }

  const completeTaskFormData = new FormData()
  completeTaskFormData.append(
    'dataForTask',
    JSON.stringify({
      status: taskData.status,
      completedDate: moment().utc(),
      completedBy: state.auth.user.userId,
      description: taskData.description,
    })
  )

  const attachments = state.Task.data.attachments

  if (attachments && attachments.length) {
    attachments.forEach((attachment) => {
      completeTaskFormData.append('attachments', attachment)
    })
  }

  // COMPLETE TASK
  const responseTaskComplete = await axios.patch(
    `/task/${id}`,
    completeTaskFormData,
    // new task creation will send email for other stepIds
    { params: { sendEmail: sendEmail && taskData.nextStepId === NONE } }
  )

  if (state.Task.isCompleting && responseTaskComplete.status === 200) {
    dispatch(getHistoryData(responseTaskComplete.data.contactId, 4))
    dispatch(setTaskCompleting(false))
  }

  //! CREATE ACTIVITY
  let responseActivity

  let activityData = {
    contactId: taskData.contactId,
    subject: taskData.title,
    notes: taskData.description,
    assigned: taskData.assigned,
    creationDate: now(),
    activityType: newActivityType,
    isDemo: taskData.isDemo,
  }

  if (activityAction === EMAIL) {
    responseActivity = await axios.post(`/activity`, {
      data: activityData,
    })
  } else if (activityAction === OUT_GOING_CALL) {
    if (c2cData && c2cData.activityId) {
      responseActivity = await axios.patch(`/activity/${c2cData.activityId}`, {
        data: activityData,
      })
    } else {
      responseActivity = await axios.post(`/activity`, {
        data: activityData,
      })
    }
  } else if (activityAction === MEETING) {
    responseActivity = await axios.post(`/activity`, {
      data: activityData,
    })
  }

  const newActivityId = responseActivity?.data[0]?.id

  if (newActivityId && isHadMeeting && eventId) {
    await axios.patch(`/events/${eventId}`, {
      activityId: newActivityId,
    })
  }

  if ((newSharedNoteId || newActivityId) && attachments?.length) {
    const taskId = responseTaskComplete?.data?.id

    const linkAttachments = {
      activityId: newActivityId,
      sharedNoteId: newSharedNoteId,
      taskId,
    }

    await axios.patch(`/activity/link-attachments/task`, linkAttachments)
  }

  // CREATE EXPENSE
  if (isHadMeeting) {
    const activityId =
      responseActivity && responseActivity.data && responseActivity.data.length > 0 && responseActivity?.data[0]?.id
        ? responseActivity.data[0].id
        : null

    dispatch(createExpense({ taskId: taskData.id, activityId, contactId: taskData.contactId }))
  }

  if (taskData.referralId) {
    await axios.patch(`/referral/${taskData.referralId}`, {
      status: 2,
      referral_on: moment().utc(),
      completeTaskNotes: taskData.description,
    })
  }
  dispatch(setIsLoading())
  dispatch(getDashboardTasks({ first: 0, limit: query.limit }, true))
  dispatch(closeModal('complete_task'))
  notificationSuccess('Task completed successfully')
}

// Follow Up Per Policy is the only next step whose date depends on a per division/contact
// setting, so it needs a round trip before it can be shown in the picker.
export const getFollowUpPerPolicyDate = async (divisionId, contactId) => {
  const { data: days } = await axios.get('/system-config/task-follow-up-per-policy', {
    params: { divisionId, contactId },
  })

  return moment().add(days, 'days').set({ hour: 17, minute: 0, second: 0 }).format('MM/DD/YYYY hh:mm a')
}

export const handleDueDate = (taskData, selectedNextStep) => {
  if (taskData.nextStepId === NO_ANSWER_CALL_BACK_2_HOURS || selectedNextStep === NO_ANSWER_CALL_BACK_2_HOURS) {
    return moment().add(2, 'hours').format('MM/DD/YYYY HH:mm')
  } else if (taskData.nextStepId === FOLLOW_UP_TOMORROW || selectedNextStep === FOLLOW_UP_TOMORROW) {
    return moment().add(1, 'day').set({ hour: 17, minute: 0, second: 0 }).format('MM/DD/YYYY HH:mm')
  } else if (taskData.nextStepId === FOLLOW_UP_NEXT_WEEK) {
    return taskData.followUpDate
  } else if (selectedNextStep === FOLLOW_UP_NEXT_WEEK || selectedNextStep === FOLLOW_UP_PER_POLICY) {
    return moment().add(1, 'week').set({ hour: 17, minute: 0, second: 0 }).format('MM/DD/YYYY HH:mm')
  } else if (!Object.keys(taskData).length) {
    const endOfWorkingDay = moment().set({ hour: 17, minute: 0, second: 0 })
    return endOfWorkingDay.format('MM/DD/YYYY HH:mm')
  }
}

export const setNextWeekDate = (value) => async (dispatch) => {
  dispatch({
    type: SET_NEXT_WEEK_DATE,
    payload: value,
  })
}

export const setInitialTaskData = (data) => async (dispatch) => {
  dispatch({
    type: SET_INITIAL_TASK_DATA,
    payload: data,
  })
}

export const setInitialEventData = (data) => async (dispatch) => {
  dispatch({
    type: SET_EVENT_DATA_FROM_TASK,
    payload: data,
  })
}

export const editTaskData = (name, value) => async (dispatch) => {
  dispatch({
    type: EDIT_TASK_DATA,
    payload: { name, value },
  })
}

export const editEventData = (name, value) => async (dispatch) => {
  dispatch({
    type: EDIT_EVENT_DATA,
    payload: { name, value },
  })
}

export const editEventDataFromTask = (name, value) => async (dispatch) => {
  dispatch({
    type: EDIT_EVENT_DATA_FROM_TASK,
    payload: { name, value },
  })
}

export const getTask = (id) => async (dispatch) => {
  const response = await axios(`task/${id}`)
  if (!isEmpty(response.data.eventData)) {
    const eventData = {
      ...response.data.eventData,
      meetingStart: response.data.eventData.meetingStart + 'Z',
      meetingEnd: response.data.eventData.meetingEnd + 'Z',
    }
    dispatch(setInitialEventData(eventData))
  }
  dispatch(setInitialTaskData(response.data))
}

export const getAssignedTasks = (contactId) => async (dispatch) => {
  const response = await axios(`task/assigned-tasks`, { params: { date: now().format('YYYY-MM-DD'), contactId } })
  dispatch({
    type: SET_NUMBER_OF_TODAY_TASKS,
    payload: response.data.dueDate ? formatDateWithTimezone(response.data.dueDate) : false,
  })
}
export const deleteTasks = (id) => async (dispatch, getState) => {
  const state = getState()
  const { query } = state.Task
  const selectedIds = state.Task.selectedTasks
  let body = []
  if (id) {
    body = [id]
  } else {
    body = selectedIds
  }
  await axios.post('/task/delete', body)
  dispatch(getDashboardTasks({ first: 0, limit: query.limit }, true))
  dispatch(getTasksSummaryCount())
}

export const deleteTaskFromContactHistoryTab = (id, contactId) => async (dispatch) => {
  const response = await axios.delete(`/task/${id}`)
  if (response.status === 200) {
    notificationSuccess('Successfully deleted task')
    dispatch(getHistoryData(contactId, 4))
  }
}

export const getDueDateTask = (date) => async (dispatch) => {
  const response = await axios(`task/due-date-task/${moment(date).format('YYYY-MM-DD')}`)
  dispatch({
    type: SET_NUMBER_OF_DUE_DATE_TASKS,
    payload: response.data.count,
  })
}

export const getDashboardTasks = (pagination, isRefresh) => async (dispatch, getState) => {
  const state = getState()
  let filters = state.Task.taskFilters

  if (filters?.dueDate) {
    let fromDate
    let toDate

    // take TZ out
    if (filters.dueDate[0]) {
      //from the start of the day 1
      fromDate = filters.dueDate[0]
        ? timeWithoutTimeZone(moment(filters.dueDate[0]).startOf('day'), 'YYYY-MM-DD HH:mm')
        : null
    }
    if (filters.dueDate[1]) {
      //till the end of the last day
      toDate = filters.dueDate[1]
        ? timeWithoutTimeZone(moment(filters.dueDate[1]).endOf('day'), 'YYYY-MM-DD HH:mm')
        : null
    }
    filters = { ...filters, dueDate: [fromDate, toDate] }
  }

  const { first, limit, secondFirst } = pagination
  const from = isRefresh ? 0 : first

  const { userId, division_id } = state.auth.user
  const response = await axios('task/tasks-for-dashboard', {
    params: { filter: { ...filters, userId, division_id }, pagination: { first: from, limit, secondFirst }, isRefresh },
  })
  dispatch({
    type: GET_TASKS_FOR_DASHBOARD,
    payload: response.data,
  })
  dispatch(getTasksSummaryCount())
}

export const clearTasksForDashboard = () => (dispatch) => {
  dispatch({
    type: CLEAR_DASHBOARD_TASKS,
  })
}

export const selectingTask = (id) => async (dispatch) => {
  dispatch({
    type: SELECT_TASK,
    payload: id,
  })
}

export const checkAll = () => async (dispatch) => {
  dispatch({
    type: CHECK_ALL,
    payload: [],
  })
}

export const getTasksSummaryCount = () => async (dispatch, getState) => {
  const state = getState()
  const { userId } = state.auth.user
  const today = now().format('YYYY-MM-DD')
  const tomorrow = now().add(1, 'days').format('YYYY-MM-DD')
  const sevenDays = now().add(7, 'days').format('YYYY-MM-DD')
  const response = await axios.post('/task/tasks-summary', {
    today,
    tomorrow,
    sevenDays,
    userId,
  })
  dispatch({
    type: SET_TASKS_SUMMARY,
    payload: response.data,
  })
}

export const setTaskFitlers = (name, value) => async (dispatch) => {
  dispatch({
    type: SET_TASK_FILTERS,
    payload: { name, value },
  })
}

async function saveMettingFromTask(selectedActivityType, eventData, contactData, taskId, activityType) {
  const { meetingStart, meetingEnd, ...rest } = eventData
  const MEETING = 10013

  if (selectedActivityType === MEETING || activityType === MEETING) {
    if (eventData.id) {
      await axios.patch(`/events/${eventData.id}`, {
        ...rest,
        meetingStart: moment(meetingStart),
        meetingEnd: moment(meetingEnd),
      })
    } else {
      await axios.post(`/events`, {
        ...rest,
        contactId: contactData.id || contactData.contactId,
        taskId,
        meetingStart: moment(meetingStart),
        meetingEnd: moment(meetingEnd),
      })
    }
  }
}

export const getDataForTaskReport = (options) => async (dispatch) => {
  const reponse = await axios.get('/task/task-report', { params: { ...options } })
  dispatch({
    type: SET_DATA_FOR_TASK_REPORT,
    payload: reponse.data,
  })
}

export const isTaskAssigned = async (userId, contactId) => {
  const response = await axios.get('/task/is-task-assigned', { params: { userId, contactId } })
  return response.data
}

export const isTodayMeetingExists = (date, userId) => async (dispatch) => {
  const response = await axios.get('/task/today-meeting', { params: { date, userId } })
  dispatch(setTodayMeeting(response.data))
}

export const setTodayMeeting = (data) => ({
  type: SET_TODAY_MEETING,
  payload: data,
})

export const setTaskEditing = (isEditing) => ({
  type: SET_TASK_EDITING,
  payload: isEditing,
})

export const setTaskCompleting = (isCompleting) => ({
  type: SET_TASK_COMPLETING,
  payload: isCompleting,
})

export const getUserTasksMonthlyStatistic = (date, userId) => async (dispatch) => {
  let normalizedUtcDate = date

  if (!date) {
    normalizedUtcDate = new Date()
  }

  normalizedUtcDate = moment.utc(normalizedUtcDate).format('YYYY-MM-DD')

  const response = await axios.get(`/task/monthly`, { params: { date: normalizedUtcDate, userId } })
  dispatch({ type: GET_USER_MONTHLY_TASK_STATISTIC, payload: response.data })
}
